import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/27eab908-ff8c-45dd-875c-f5e640a39dd0";
export const REGISTER_URL = "https://a.ntrk2.com/f6f94233-dc4e-4eb8-8c79-0c91a52a6009";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://ezwin.loadprkw2a.com/download?openExternalBrowser=1&id=cmionnk8wno8axn";
